(function () {
  function initRoot(root) {
    var poolEl = document.getElementById('RojiSlotPool-' + root.dataset.sectionId);
    if (!poolEl) return;

    var pool;
    try {
      pool = JSON.parse(poolEl.textContent);
    } catch (e) {
      return;
    }
    if (!pool || !pool.length) return;

    var interval = parseInt(root.dataset.interval, 10) || 2000;
    var wraps = root.querySelectorAll('.roji-slot__img-wrap');
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function randomItem() {
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function swap(wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;
      var next = randomItem();

      if (reduceMotion) {
        img.src = next.src;
        img.alt = next.alt || '';
        return;
      }

      wrap.classList.add('roji-slot__img-wrap--leaving');
      window.setTimeout(function () {
        img.src = next.src;
        img.alt = next.alt || '';
        wrap.classList.remove('roji-slot__img-wrap--leaving');
        wrap.classList.add('roji-slot__img-wrap--entering');
        // Force reflow so the browser registers the entering position
        // before the class is removed and the transition kicks in.
        void wrap.offsetWidth;
        wrap.classList.remove('roji-slot__img-wrap--entering');
      }, 320);
    }

    if (pool.length < 2 || !wraps.length) return;

    window.setInterval(function () {
      wraps.forEach(function (wrap) {
        window.setTimeout(function () {
          swap(wrap);
        }, Math.random() * 300);
      });
    }, interval);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.roji-slot-designs').forEach(initRoot);
  });
})();
